import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../components/base/edit-text/edit-text';
import Button from '../../../../components/base/button/button';
import i18n from '../../../../translations/strings';
import { CompleteResetPasswordFormStyled } from './complete-reset-password-form.styled';

const ChangePasswordForm = (props: any) => {
  const {
    control,
    formState: { errors },
    register,
    handleSubmit,
  } = useFormContext();

  return (
    <CompleteResetPasswordFormStyled.Container>

      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            isPassword
            error={errors?.password?.message?.toString()}
            fullWidth
            {...register('password')}
            defaultValue={value}
            placeholder={i18n.t('common.password')}
            onChange={onChange}
            label={i18n.t('common.password')}
          />
        )}
        name="password"
      />
      <CompleteResetPasswordFormStyled.Separator />
      <Controller
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <EditText
            isPassword
            error={errors?.confirm_password?.message?.toString()}
            fullWidth
            {...register('confirm_password')}
            defaultValue={value}
            placeholder={i18n.t('confirmResetPassword.confirmPassword')}
            onChange={onChange}
            label={i18n.t('confirmResetPassword.confirmPassword')}
          />
        )}
        name="confirm_password"
      />
      <CompleteResetPasswordFormStyled.Separator />
      <CompleteResetPasswordFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('confirmResetPassword.changePassword')}
        />
      </CompleteResetPasswordFormStyled.ContainerButton>
    </CompleteResetPasswordFormStyled.Container>
  );
};

export default ChangePasswordForm;
